"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _assertResponseError = require("./assertResponseError");
Object.keys(_assertResponseError).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _assertResponseError[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _assertResponseError[key];
    }
  });
});